import { getHttpApi } from '@cian/http-api/browser';
import { TOfferType } from '@cian/api-models/offer-card/v1/get-offer-data';

export function getHtmlFotoramaComponent(price: number, type: string, subtype: string) {
  return getHttpApi().fetch(
    {
      apiType: 'public',
      assertStatusCodes: [200],
      method: 'GET',
      microserviceName: 'financeOfferFotoramaFrame',
      pathApi: '/stub',
      parameters: {
        price,
        type,
        subtype,
      },
    },
    {
      requestConfig: {
        withCredentials: true,
      },
    },
  );
}

export function calculateParametersCombination(
  price?: number,
  isAppartment?: boolean,
  isNewBuilding?: boolean,
  offerType?: TOfferType,
) {
  if (
    typeof offerType === 'undefined' ||
    typeof isNewBuilding === 'undefined' ||
    typeof isAppartment === 'undefined' ||
    typeof price === 'undefined'
  ) {
    return undefined;
  }
  const type = isNewBuilding ? 'NEW' : 'USED';
  let subtype = 'FLAT';
  if (offerType === 'suburban') {
    subtype = 'COTTAGE';
  } else if (offerType === 'flat') {
    subtype = isAppartment ? 'APARTMENTS' : 'FLAT';
  } else {
    return undefined;
  }

  return { price, type, subtype };
}
